import { Modal as CartModal } from '../../../Cart/components/Modal';

export const Modals: React.FC = () => (
	<>
		<CartModal />
	</>
);
